import React, { memo } from 'react';
import { formatNumberToPlaces } from 'utils/numbers';
import { Box, Image } from 'components/Wrapped';
import { PrettyNumberTZ } from 'components/Helpers';

const OrderBookLastPrice = memo(({ width, side, lastPrice, tickDecimals }) => {
  return (
    <React.Fragment>
      <Box
        background="transparent"
        pad="none"
        margin={{ vertical: '8px' }}
        round={false}
        fill={false}
        style={{ height: 20, width }}
        basis="auto"
      >
        <Box pad="none" direction="row" justify="between" align="center" gap="small">
          <Box textAlignment="centered" style={{ flex: 1 }} fontFamily="alt" direction="row" align="center" gap="4px" pad="none">
            <PrettyNumberTZ
              number={formatNumberToPlaces(lastPrice, tickDecimals)}
              color={side ? (side === 'BUY' ? '#46B08E' : '#E56150') : 'text'}
              size="18px"
              weight={500}
              style={{ lineHeight: '20px' }}
            />
            {side === 'BUY' ? <Image src="/assets/img/icons/up.svg" /> : <Image src="/assets/img/icons/down.svg" />}
          </Box>
          {/* <Text size="12px" fontFamily="alt" weight={500}>
               <FiatConverter
                 isFiat={true}
                 lastPrice={lastPrice}
                 market={tradingPair.quoteCurrency}
                 color="text"
               />
             </Text> */}
        </Box>
      </Box>
    </React.Fragment>
  );
});

export default OrderBookLastPrice;
